import { render, staticRenderFns } from "./Peso.vue?vue&type=template&id=877414f2&"
import script from "./Peso.vue?vue&type=script&lang=js&"
export * from "./Peso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports